import { WidgetNames } from '../config.type';
import { UiZoneWidgetConfig, isNewUiZoneWidgetConfig } from '../ui-system-config.v2.type';

export function findWidgetWithName(
  name: WidgetNames,
  widgets: UiZoneWidgetConfig[],
): UiZoneWidgetConfig | null {
  for (const widget of widgets) {
    if (widget.name === name) {
      return widget;
    }

    if (isNewUiZoneWidgetConfig(widget)) {
      if (widget.childComponents) {
        let result: UiZoneWidgetConfig | null = null;

        if (Array.isArray(widget.childComponents[0])) {
          // Handle 2D array of child components
          for (const childArray of widget.childComponents as UiZoneWidgetConfig[][]) {
            result = findWidgetWithName(name, childArray);
            if (result) break;
          }
        } else {
          // Handle 1D array of child components
          result = findWidgetWithName(name, widget.childComponents as UiZoneWidgetConfig[]);
        }
        if (result) {
          return result;
        }
      }
    }
  }

  return null;
}
